import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import Loading from "../../components/Loading/Loading"
import React from "react"
import {useParams} from "react-router"
import {getBank} from "../../resources/bank"
import {Bank as BankType} from "../../resources/bank"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import RiskSettings from "../BankSettings/RiskSettings/RiskSettings"
import PaymentRulesForBank from "../BankSettings/PaymentRulesForBank"
import {useListReturnPath} from "../../hooks/useListReturnPath"
import classNames from "classnames"
import {useQueryState} from "use-location-state"

type BankPageTabs = "Payment Rules" | "Onboarding Rules"

interface PageProps {
	bank: BankType
}

function Page({bank}: PageProps) {
	const listReturnPath = useListReturnPath("/banks/")
	const [currentTab, setCurrentTab] = useQueryState<BankPageTabs>("tab", "Onboarding Rules")
	return (
		<>
			<TitleBar breadcrumbs={[{text: "Banks", path: listReturnPath}]} title={bank.attributes.name} meta={[]} noBorder />
			<nav className="bank-settings tabs-container">
				<div className="tabs">
					<ul>
						<li
							className={classNames(currentTab == "Onboarding Rules" && "is-active")}
							onClick={() => setCurrentTab("Onboarding Rules")}
						>
							<a>Onboarding Rules</a>
						</li>
						<li
							className={classNames(currentTab == "Payment Rules" && "is-active")}
							onClick={() => setCurrentTab("Payment Rules")}
						>
							<a>Payment Rules</a>
						</li>
					</ul>
				</div>
			</nav>
			<MainSection>
				{currentTab == "Payment Rules" ? (
					<PaymentRulesForBank bankId={bank.id} />
				) : (
					<RiskSettings bankId={bank.id} title="Onboarding Rules" />
				)}
			</MainSection>
		</>
	)
}

export default function Bank() {
	const accessToken = useAccessToken()
	const {bankId = ""} = useParams<{bankId: string}>()

	const bank = useAsyncResult(() => getBank(accessToken, bankId), [])

	return (
		<AsyncResultComponent asyncResult={bank} pendingComponent={<Loading />}>
			{({value: bank}) => {
				return <Page bank={bank} />
			}}
		</AsyncResultComponent>
	)
}
